import React, { useState } from 'react';

const ImageCarousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className="w-full">
      {/* Mobile view - single image carousel */}
      <div className="md:hidden">
        <div className="flex items-center justify-center">
          <button 
            onClick={prevImage}
            className="p-2 text-gray-600"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <div className="w-[200px] h-[200px]">
            <img 
              src={images[currentIndex]} 
              alt={`Product ${currentIndex + 1}`}
              className="w-full h-full object-cover"
            />
          </div>

          <button 
            onClick={nextImage}
            className="p-2 text-gray-600"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>

      {/* Desktop view - all images */}
      <div className="hidden md:px-8 md:grid md:grid-cols-5 justify-center">
        {images.map((image, index) => (
          <div key={index} className="w-[200px] h-[200px]">
            <img 
              src={image} 
              alt={`Product ${index + 1}`}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;
